export default "__VITE_ASSET__BnhyjoVP__"